import { BLACKLIST_EMAIL_PROVIDERS } from 'constants/blacklist-email-providers';
import { GENERIC_EMAIL_PROVIDERS } from 'constants/generic-email-providers';

export const normalizeEmail = (email: string) => {
  return email.trim().toLowerCase();
};

export const isGenericEmail = (email: string) => {
  const domain = getDomain(email);
  return domain in GENERIC_EMAIL_PROVIDERS;
};

export const isDisposableEmail = (email: string) => {
  const domain = getDomain(email);
  return domain in BLACKLIST_EMAIL_PROVIDERS;
};

export const getDomain = (email: string) => {
  return (email.split('@')[1] || '').toLowerCase();
};
